import _ from 'lodash'
import { forwardRef } from 'react'

type Props = {
  id: string
  name: string
  checked?: boolean
  className?: string
  label: string | React.ReactNode
  value?: string | number | null | any
  disabled?: boolean
  onChange: (val: any) => void
} & React.ComponentPropsWithoutRef<'input'>

export const Radio = forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const { id, name, checked, label, onChange } = props
  function handleChange(e: any) {
    onChange(e.target.value)
  }
  return (
    <div className='flex items-start w-full hover:cursor-pointer py-1.5'>
      <label className='relative flex items-center cursor-pointer pr-2' htmlFor={`${name}_${id}`}>
        <input
          defaultChecked={checked}
          id={`${name}_${id}`}
          value={id}
          name={name}
          type='radio'
          className='form-radio'
          onChange={handleChange}
          ref={ref}
        />
      </label>
      <label className='form-inline-label flex-1 truncate' htmlFor={`${name}_${id}`}>
        {label}
      </label>
    </div>
  )
})